/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Market_Cap_To_Fdv_NameInputs */



/**
* | output |
* | --- |
* | "Market Cap / FDV" |
*
* @param {Metric_Market_Cap_To_Fdv_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_market_cap_to_fdv_name = /** @type {((inputs?: Metric_Market_Cap_To_Fdv_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Market_Cap_To_Fdv_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Market Cap / FDV")
});